module.exports = __webpack_public_path__ + "img/region_soconusco.e26a6019.svg";